import { format } from "date-fns";

import type { AdvisorInfoSchema } from "@fartherfinance/frontend/api/Entity/Types";
export const formatTransitionDate = (date: Date): string => {
  return format(date, "MM/dd/yyyy");
};

export const formatPercentage = (value: number) => `${value}%`;

export const joinAdvisorNames = (advisors: AdvisorInfoSchema[]): string => {
  return advisors.map((advisor) => advisor.fullName).join(", ");
};

export const selectFirstTransitionAdvisor = (
  advisors: AdvisorInfoSchema[]
): AdvisorInfoSchema | undefined => {
  return advisors.at(0);
};
